/**
 * Fetches an image with JWT authorization and returns a blob URL
 * @param {string} imagePath - The image path/URL
 * @param {string} token - JWT authorization token
 * @returns {Promise<string>} - Blob URL for the image
 */
export default async function loadProtectedImage(imagePath, token) {
    try {
        // Convert /images/ path to /api/images/ for the protected API route
        const apiPath = imagePath.replace('/images/', '/api/images/');

        const response = await fetch(apiPath, {
            headers: {
                'Authorization': token
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to load image: ${response.status}`);
        }

        const blob = await response.blob();
        return URL.createObjectURL(blob);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading protected image:', error);
        return '';
    }
}
